"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyGeneralCatalogItem = void 0;
function makeEmptyGeneralCatalogItem() {
    return {
        id: -1,
        code: '',
        name: '',
    };
}
exports.makeEmptyGeneralCatalogItem = makeEmptyGeneralCatalogItem;
//# sourceMappingURL=GeneralCatalogItem.js.map